
import { FAQ_LIST, FAQ_SEARCH } from '~/const/api/faq';
import FaqSection from '~/components/faq/FaqSection';
import FaqNavigation from '~/components/faq/FaqNavigation';
import AppDataWaiting from '~/components/common/AppDataWaiting';
import FaqBanner from '@/components/faq/FaqBanner';
import LayoutContainer from '@/components/layout/Container';

export default {
    name: 'FAQ',
    head: {
        title: 'Ответы на вопросы о платформе Ко-Фи',
        meta: [
            { 
                hid: 'og:title',
                name: 'og:title',
                property: 'og:title',
                content: 'Ответы на вопросы о платформе Ко-Фи'
            },
            {
                hid: 'description',
                name: 'description',
                content: 'Часто задаваемые вопросы о платформе Ко-Фи и ответы на них.',
            },
            { 
                hid: 'og:description',
                name: 'og:description',
                property: 'og:description',
                content: 'Часто задаваемые вопросы о платформе Ко-Фи и ответы на них.'
            },
        ]
    },
    components: {
        FaqNavigation,
        FaqSection,
        AppDataWaiting,
        FaqBanner,
        LayoutContainer
    },
    async fetch() {
        await this.$axios.get(FAQ_LIST)
            .then(({ data }) => {
                this.faq = data || [],
                this.currentSection = this.faq?.[0]
            })
    },
    data() {
        return {
            searchValue: '',
            sentFormSearch: false,
            faq: null,
            currentSection: null,
            resultSearch: null,
            page: 1
        }
    },
    computed: {
        faqLinks() {
            return this.faq && this.faq.map(item => {
                return {
                    text: item.name,
                    name: item.name,
                    ...item
                }
            })
        }
    },
    methods: {
        handleChangeSection(section) {
            console.warn('handleChangeSection');
            this.currentSection = section;
            this.resultSearch = null;
        },
        handleSubmit() {
            this.sentFormSearch = true;
            const prevResult = this.currentSection
            this.resultSearch = this.currentSection = null;

            this.$axios.post(FAQ_SEARCH, { search: this.searchValue })
                .then(({ data }) => {
                    if (data) this.resultSearch = data;
                })
                .catch(err => {
                    this.$notify({
                        type: 'error',
                        title: 'Возникла ошибка! Корректно заполните поле поиска.'
                    })
                    this.requestSearch = false
                    this.resultSearch = prevResult
                })
                .finally(() => {
                    this.requestSearch = false;
                });
        },
        handleInput(e) {
            this.searchValue = e.target.value;
            this.sentFormSearch = false;
        },
        handleClearInput() {
            this.searchValue = '';
            this.sentFormSearch = false;
            this.currentSection = this.faq?.[0] || null;
            this.resultSearch = null;
        }
    }
}
